export default __webpack_public_path__ + "static/media/ico-telephone-line.dccafc50.svg";